// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3KXId","signatureButtonsRight":"ModalSign_signatureButtonsRight__1KQpT"};